/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  fill: "none",
  transform: "matrix(0.57213929,0,0,0.57213929,0.5572142,0.5572142)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "20",
  cy: "20",
  r: "19.6",
  fill: "#ffffff",
  fillOpacity: "0.5",
  stroke: "#a400e1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a400e1",
  d: "m 14.267,13.093 v 13.814 c 0,1.053 1.16,1.693 2.053,1.12 L 27.173,21.12 C 28,20.6 28,19.4 27.173,18.867 L 16.32,11.973 c -0.893,-0.573 -2.053,0.067 -2.053,1.12 z"
})), 'VideoCircle');